import { gql } from 'apollo-boost';

export const updateQuicksightDashboard = gql`
mutation updateQuicksightDashboard (
  $id: Int!,
  $name: String,
  $information: String
  $awsId: String,
  $accountList: String,
) {
updateQuicksightDashboard (
  id: $id,
  name: $name,
  information: $information
  awsId: $awsId,
  accountList: $accountList
) {
    success
    id
  }
}
`;
